import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { AppService } from "./app.service";

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  
  private tiktokPosts$: Promise<any>;

  constructor(
    private http: HttpClient,
    private appService: AppService
  ) {}

  getTiktokPosts() {
    if(!this.tiktokPosts$) {
      this.tiktokPosts$ = lastValueFrom(this.http.get(`${this.appService.getAppBaseUrl()}/medias?page=home&section=tiktok-recent-posts`));
    }
    return this.tiktokPosts$;
  }
}
